import { ITargetDataForUpdate } from "./sbCampaignApi.types"

export interface IGetSbTargetBody {
  fromDate: string
  toDate: string
  campaignIds: string[]
  filterType: FILTER_TYPES
}

export enum FILTER_TYPES {
  DATE = "Date",
  ORDERS = "Orders",
}

export interface ISbTargetResult {
  campaignId: string
  targetData: ITargetData[]
}

export interface ITargetData {
  acos: number
  adGroupId: string
  bestCVRCPC: number
  bid: number
  campaignId: string
  clicks: number
  cpc: number
  ctr: number
  cvr: number
  impressions: number
  orders: number
  roas: number
  sales: number
  spend: number
  targetAcos: number
  targetCPCAmazon: number
  targetCVRCPC: number
  targetId: string
  targetName: string
  targetStatus: string
  units: number
  limitedCPC: number | null
}

export interface IUpdateSpTargetParams {
  targetData: ITargetDataForUpdate[]
}
